{
    "CX_Record_Licences_None": "Aucun",
    "CX_Record_Licences_CXRRecord": "Enregistrement radiographique du thorax",
    "CX_Record_Licences_CXRUser": "Utilisateur CXR",
    "CX_Record_Licences_CXRManager": "Responsable CXR",
    "CX_Record_Device_Or_Agent_Error": "Un agent ou un appareil est requis pour un abonnement {}",
    "NAME": "CXRecordLanguage"
}